import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { EquipoTecnologico, RequestResponseGetAllEquipoTecnologico, RequestResponseActualizar } from 'src/app/shared/models/equipo-tecnologico.interface';


@Injectable({
  providedIn: 'root'
})
export class EquipoTecnologicoService {


  constructor(private http: HttpClient, private router: Router, private alert: AlertHelper) { }

  //GetAll_equiposTecnologicos
  traerEquipos(): Observable<RequestResponseGetAllEquipoTecnologico> {
    return this.http
      .get<RequestResponseGetAllEquipoTecnologico>(`${environment.API}/rrhh/equipoTecnologico/`)
      .pipe(
        map((res: RequestResponseGetAllEquipoTecnologico) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  //Buscar_equiposTecnologicos (filtra por modelo o numeroSerie)
  buscarEquipos(texto: string): Observable<RequestResponseGetAllEquipoTecnologico> {
    return this.http
      .get<RequestResponseGetAllEquipoTecnologico>(`${environment.API}/rrhh/equipoTecnologico/?search=${texto}`)
      .pipe(
        map((res: RequestResponseGetAllEquipoTecnologico) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  //Create_equipoTecnologico
  crearEquipo(equipo: EquipoTecnologico): Observable<RequestResponse> {
    return this.http
      .post<RequestResponse>(`${environment.API}/rrhh/equipoTecnologico/crear`, equipo)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  //Obtener_equipoTecnologico_porId
  traerEquipoPorId(id: number): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/equipoTecnologico/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  //Buscar_equipoTecnologico_porNumeroSerie (detecta duplicados antes de crear)
  buscarEquipoPorSerie(numeroSerie: string): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/equipoTecnologico/serie/${numeroSerie}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  //Actualizar_equipoTecnologico
  actualizarEquipo(equipo: any): Observable<RequestResponseActualizar> {
    return this.http
      .put<RequestResponseActualizar>(`${environment.API}/rrhh/equipoTecnologico/actualizar/${equipo.id}`, equipo)
      .pipe(
        map((res: RequestResponseActualizar) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }

  //Actualizar_estado_equipoTecnologico
  actualizarEstadoEquipo(id: number, estado: string): Observable<RequestResponseActualizar> {
    return this.http
      .put<RequestResponseActualizar>(`${environment.API}/rrhh/equipoTecnologico/actualizarEstado/${id}`, { estado })
      .pipe(
        map((res: RequestResponseActualizar) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }


  private handlerError(err: any): Observable<never> {

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }

}
